module.exports = __webpack_public_path__ + "cfadb3ce94967b2d061189da5ae75073.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/winking-3.png
// module id = 1781
// module chunks = 0